import { ElementRef, EventEmitter, OnDestroy, OnInit, Directive } from '@angular/core';

@Directive()
export class OutsideEventDirective implements OnInit, OnDestroy {
  wfmOutsideEvent = new EventEmitter();

  private window: Window;

  constructor(private document, private element: ElementRef, private eventName: string) {
    this.window = this.document.defaultView;
  }

  eventListener = (event: MouseEvent) => {
    const isInside = this.element.nativeElement === event.target || this.element.nativeElement.contains(event.target);

    if (!isInside) {
      this.wfmOutsideEvent.emit();
    }
  };

  ngOnInit() {
    this.window.document.addEventListener(this.eventName, this.eventListener);
  }

  ngOnDestroy() {
    this.window.document.removeEventListener(this.eventName, this.eventListener);
  }
}
